var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-page-title',{on:{"addEvent":function($event){return _vm.$router.push({name: 'addProduct'})}}},[_vm._v("الطلبات")]),_c('main-table',{attrs:{"fields":_vm.fields,"list_url":"merchant/orders"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }